// @flow

import type { DocumentNode } from 'graphql';

import type { CacheType } from 'app/graphql/types';

type ResultType = {
  data: any,
};

export const buildCreationUpdater = ({
  queryKey,
  mutationKey,
}: {
  queryKey: string,
  mutationKey: string,
}) => (query: DocumentNode, variables: {}) => (
  cache: CacheType,
  mutationResult: ResultType
) => {
  const fullQuery = {
    query,
    variables,
  };
  const cachedQueryResult = cache.readQuery(fullQuery);
  const cachedQueryItems = cachedQueryResult[queryKey];
  const newItem = mutationResult.data[mutationKey];
  cache.writeQuery({
    ...fullQuery,
    data: {
      [queryKey]: [...cachedQueryItems, newItem],
    },
  });
};

export const buildDeletionUpdater = ({
  queryKey,
  mutationKey,
}: {
  queryKey: string,
  mutationKey: string,
}) => (query: DocumentNode, variables: {}) => (
  cache: CacheType,
  mutationResult: ResultType
) => {
  const fullQuery = {
    query,
    variables,
  };
  const cachedQueryResult = cache.readQuery(fullQuery);
  const cachedQueryItems = cachedQueryResult[queryKey];
  const newItem = mutationResult.data[mutationKey];
  cache.writeQuery({
    ...fullQuery,
    data: {
      [queryKey]: cachedQueryItems.filter(item => item.id !== newItem.id),
    },
  });
};
